export default __webpack_public_path__ + "static/media/SN5-1.75cfca90.jpg";